import { lazy } from "react";

const Pettycashreapproew = lazy(() => import("./Pettycashreapproew"));

const pettycashreapproewRoutes = [
  {
    path: "/pettycashreapproew",
    component: Pettycashreapproew,
  },
];

export default pettycashreapproewRoutes;
